webpackJsonp([64832062114608],{

/***/ 1799:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"HarvestLabOrderDetail","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"id","type":{"kind":"SCALAR","name":"ID","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---object-harvest-lab-order-detail-05d4f155ad7b4b754bc4.js